import { render, staticRenderFns } from "./SewageTankTable.vue?vue&type=template&id=049e2371&scoped=true&"
import script from "./SewageTankTable.vue?vue&type=script&lang=js&"
export * from "./SewageTankTable.vue?vue&type=script&lang=js&"
import style0 from "./SewageTankTable.vue?vue&type=style&index=0&id=049e2371&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049e2371",
  null
  
)

export default component.exports